import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from "@angular/core";
import { RouterLink } from "@angular/router";
import { UserAvatarComponent } from "../../../../shared/components/user-avatar/user-avatar.component";
import { APP_NAME } from "../../../../core/constants/app.constants";

@Component({
  selector: "app-chat-sidebar",
  standalone: true,
  imports: [RouterLink, UserAvatarComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./chat-sidebar.component.html",
  styleUrl: "./chat-sidebar.component.scss",
})
export class ChatSidebarComponent {
  readonly appName = APP_NAME;
  readonly displayName = input<string>("");
  readonly avatarUrl = input<string | null>(null);
  readonly darkMode = input<boolean>(false);

  readonly openProfile = output<void>();
  readonly toggleDarkMode = output<void>();
  readonly startNewChat = output<void>();
}
